export default (state={ isEditing: false , data: {}, }, action) => {
	switch(action.type) {
		case 'ACCOUNT_GET_REQUEST':
			return {
				...state,
				isFetching: true,
				data: {},
				error: false,
			}
		case 'ACCOUNT_GET_SUCCESS':
			return {
				...state,
				isFetching: false,
				data: action.result,
				error: false,
			}
		case 'ACCOUNT_GET_ERROR':
			return {
				...state,
				isFetching: false,
				error: action.payload,
			}
		case 'ACCOUNT_UPDATE_ERROR':
      // TODO: handle update error!
      return state;
    case 'ACCOUNT_UPDATE_SUCCESS':
      // console.log(action);
      return {
        ...state,
        data: action.result,
      }
		default:
			return state;
	}

}


// WEBPACK FOOTER //
// ./src/modules/account/account.reducer.js